import { Box, Text } from "@chakra-ui/react"
//import React, { MouseEvent } //Vishy 2025-02-18 build warning - MouseEvent not used
import React from "react";

type Props = {
    onClick: any;
    icon: React.ReactNode;
    buttonBg: string;
    width?: string;  // Claude: Optional width override for variable nav item counts 16-02-2026
    label?: string;  // Claude: Optional label below icon 24-02-2026
    active?: boolean; // Claude: Active state drives label colour 24-02-2026
    showBadge?: boolean; // Claude: red dot indicator for new RFX activity 03-03-2026
}
const CustomIconButton = (props: Props) => {
    return (
        <Box
            w={props.width || "20%"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={"2px"}
            // _hover={{ backgroundColor: "icon.hover" }}
            onClick={props.onClick}
            cursor={"pointer"}
            bg={props.buttonBg}
        >
            {/* Claude: wrap icon in relative box to allow badge overlay 03-03-2026 */}
            <Box position="relative" display="inline-flex">
                {props.icon}
                {props.showBadge && (
                    <Box
                        position="absolute"
                        top="-2px"
                        right="-2px"
                        w="8px"
                        h="8px"
                        borderRadius="50%"
                        bg="red.500"
                    />
                )}
            </Box>
            {props.label && (
                <Text fontSize={"9px"} color={props.active ? "#FF5F12" : "#1C1B1F"} lineHeight={1}>
                    {props.label}
                </Text>
            )}
        </Box>
    )
}

export default CustomIconButton